
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Bell, Check } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div>
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Inbox</div>
        <h1 className="text-4xl font-bold text-zinc-900 mt-1" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Notifications
        </h1>
        <p className="text-sm text-zinc-500 mt-1">In-app preview of emails the system will route via Microsoft Graph once integrated.</p>
      </div>

      <div className="border border-zinc-200 bg-white divide-y divide-zinc-100">
        {items.map((n) => (
          <div key={n.id} className={`px-5 py-4 flex items-start gap-3 ${n.read ? "opacity-60" : ""}`}>
            <Bell className="w-4 h-4 mt-0.5 text-zinc-500" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium">{n.subject}</div>
              <div className="text-sm text-zinc-600 mt-0.5">{n.body}</div>
              {n.review_id && (
                <Link to={`/reviews/${n.review_id}`} className="text-xs text-blue-600 hover:underline mt-1 inline-block">Open review →</Link>
              )}
              <div className="text-[10px] uppercase tracking-wider text-zinc-400 mt-2">
                {new Date(n.created_at).toLocaleString()}
              </div>
            </div>
            {!n.read && (
              <button onClick={() => markRead(n.id)} className="text-xs text-zinc-600 hover:text-zinc-900 flex items-center gap-1">
                <Check className="w-3.5 h-3.5" /> Mark read
              </button>
            )}
          </div>
        ))}
        {items.length === 0 && (
          <div className="px-5 py-16 text-center text-zinc-500 text-sm">No notifications.</div>
        )}
      </div>
    </div>
  );
}
